export const REQUEST_PARTIAL_VALIDATION_EVENT = 'request-partial-validation';

export const FAILED_PARTIAL_VALIDATION_EVENT = 'failed-partial-validation'
export const PASSED_PARTIAL_VALIDATION_EVENT = 'passed-partial-validation'

export const SUBMIT_FAILED_EVENT = 'submit-failed'
export const SUBMIT_SUCCESS_EVENT = 'submit-success'

export const ACTION_FAILED_EVENT = 'action-failed'
export const ACTION_SUCCESS_EVENT = 'action-success'
export const ACTION_ENDED_EVENT = 'action-ended'
